import { CommonModule } from '@angular/common';
import { Component, ElementRef } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { SelectModule } from 'primeng/select';
import { AppMenuComponent } from './app.menu.component';
import { EntitySelectionService } from './service/entity-selection.service';
import { LayoutService } from './service/app.layout.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './app.sidebar.component.html',
  standalone: true,
  styleUrls: ['./app.sidebar.component.scss'],
  imports: [CommonModule, FormsModule, SelectModule, AppMenuComponent],
})
export class AppSidebarComponent {
  constructor(
    public layoutService: LayoutService,
    public entitySelectionService: EntitySelectionService,
    public el: ElementRef,
  ) {}
}
